module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cqvp2"))).then(() => module.bundle.root('3a9aZ'));